export default __webpack_public_path__ + "static/media/AU.97149874.ico";